import FeaturedItem from "./FeaturedItem";
export default FeaturedItem;